/* eslint-disable linebreak-style */
/* eslint-disable import/extensions */
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/jsx-filename-extension */
/* eslint-disable import/no-extraneous-dependencies */
import React, { Component } from 'react';
import { Helmet } from 'react-helmet-async';

import { landingPage } from 'json/landingPageData';
import Header from 'parts/Header';
import Hero from 'parts/Hero';
import Seo from 'parts/Seo';

const Service = React.lazy(() => import('parts/Service'));
const Portfolio = React.lazy(() => import('parts/Portfolio'));
const Advantage = React.lazy(() => import('parts/Advantage'));
const Discuss = React.lazy(() => import('parts/Discuss'));
const Footer = React.lazy(() => import('parts/Footer'));

export default class LandingPage extends Component {
  componentDidMount() {
    window.scrollTo(0, 0);
  }

  render() {
    return (
      <>
        <Seo
          title="Teknisi CNC Profesional | Jasa Service & Perbaikan Mesin CNC Terpercaya"
          description="Jasa teknisi CNC berpengalaman untuk service, perbaikan, maintenance, retrofit, dan upgrade mesin CNC & Laser CO2. Layanan panggilan ke seluruh Indonesia. Hubungi kami sekarang!"
          keywords="teknisi cnc, service cnc, perbaikan cnc, jasa servis mesin cnc, teknisi cnc panggilan, maintenance cnc, retrofit cnc, servis laser co2, teknisi mesin cnc, service cnc jakarta, perbaikan mesin cnc, jasa teknisi cnc, upgrade cnc, cnc router service, cnc milling service, service mesin industri, perbaikan mesin industri indonesia"
          canonicalUrl="https://teknisi.space/"
        />
        <Helmet>
          <script type="application/ld+json">
            {`
              {
                "@context": "https://schema.org",
                "@type": "LocalBusiness",
                "@id": "https://teknisi.space/#business",
                "name": "Teknisi CNC",
                "alternateName": "Teknisi CNC Indonesia",
                "image": "https://teknisi.space/logo512.png",
                "logo": "https://teknisi.space/logo192.png",
                "description": "Jasa teknisi CNC profesional untuk service, perbaikan, maintenance, retrofit, dan upgrade mesin CNC & Laser CO2. Layanan panggilan ke seluruh Indonesia.",
                "url": "https://teknisi.space",
                "telephone": "+6285179671905",
                "email": "oknumteknisi@gmail.com",
                "priceRange": "$$",
                "address": {
                  "@type": "PostalAddress",
                  "addressLocality": "Jakarta",
                  "addressRegion": "DKI Jakarta",
                  "addressCountry": "ID"
                },
                "geo": {
                  "@type": "GeoCoordinates",
                  "latitude": -6.2088,
                  "longitude": 106.8456
                },
                "areaServed": {
                  "@type": "Country",
                  "name": "Indonesia"
                },
                "serviceType": [
                  "Service Mesin CNC",
                  "Perbaikan Laser CO2",
                  "Maintenance Mesin Industri",
                  "Retrofit CNC",
                  "Upgrade Kontroler CNC",
                  "Training CNC"
                ],
                "hasOfferCatalog": {
                  "@type": "OfferCatalog",
                  "name": "Layanan Teknisi CNC",
                  "itemListElement": [
                    {
                      "@type": "Offer",
                      "itemOffered": {
                        "@type": "Service",
                        "name": "Service Mesin CNC",
                        "description": "Jasa perbaikan dan maintenance mesin CNC Router, CNC Milling, CNC Lathe"
                      }
                    },
                    {
                      "@type": "Offer",
                      "itemOffered": {
                        "@type": "Service",
                        "name": "Service Laser CO2",
                        "description": "Perbaikan dan tune-up mesin laser cutting CO2"
                      }
                    },
                    {
                      "@type": "Offer",
                      "itemOffered": {
                        "@type": "Service",
                        "name": "Retrofit & Upgrade CNC",
                        "description": "Upgrade kontroler dan retrofit mesin CNC lama menjadi lebih modern"
                      }
                    }
                  ]
                },
                "openingHoursSpecification": [
                  {
                    "@type": "OpeningHoursSpecification",
                    "dayOfWeek": [
                      "Monday",
                      "Tuesday",
                      "Wednesday",
                      "Thursday",
                      "Friday",
                      "Saturday"
                    ],
                    "opens": "08:00",
                    "closes": "17:00"
                  }
                ],
                "sameAs": [
                  "https://www.instagram.com/bayghf/"
                ]
              }
            `}
          </script>
          <script type="application/ld+json">
            {`
              {
                "@context": "https://schema.org",
                "@type": "WebSite",
                "name": "Teknisi CNC",
                "alternateName": "Teknisi CNC Indonesia",
                "url": "https://teknisi.space",
                "description": "Jasa teknisi CNC profesional untuk service, perbaikan, dan maintenance mesin CNC & Laser CO2 di Indonesia",
                "potentialAction": {
                  "@type": "SearchAction",
                  "target": "https://teknisi.space/?q={search_term_string}",
                  "query-input": "required name=search_term_string"
                }
              }
            `}
          </script>
        </Helmet>
        <Header />
        <Hero />
        <React.Suspense fallback={<div>Loading...</div>}>
          <Service data={landingPage.service} />
          <Portfolio data={landingPage.portfolio} />
          <Advantage data={landingPage.advantage} />
          <Discuss />
          <Footer />
        </React.Suspense>
      </>
    );
  }
}
